import React from "react";

function ContentComponent({ text }) {
  return (
    <p className="text-base leading-6 md:leading-8  text-neutral-100">{text}</p>
  );
}

export default ContentComponent;
